import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DataEndChannel } from 'src/app/project/shared/interfaces/data-end-channel.interface';
import { SetDoControl } from 'src/app/project/shared/interfaces/set-do-control';
import { DataEndChannelService } from 'src/app/project/shared/services/data-end-channel.service';
import { AlertTypes } from 'src/app/shared/alert/shared/alert-types';
import { AlertService } from 'src/app/shared/alert/shared/alert.service';

@Component({
  selector: 'avs-set-di-control',
  standalone: false,
  templateUrl: './set-di-control.component.html',
  styleUrl: './set-di-control.component.css'
})
export class SetDiControlComponent implements OnInit, OnChanges {
  @Input() selectedDiChannel?: DataEndChannel; /*  */


  public state: boolean = false; /* deChannel auslesen <-- */
  public stateChanged: boolean = false;
  constructor(private dataEndChannelService: DataEndChannelService, private alertService: AlertService) {
  }

  ngOnInit(): void {
    this.parseChannelState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDiChannel'] && this.selectedDiChannel) {
      this.parseChannelState();
    }
  }

  private parseChannelState(): void {
    if (this.selectedDiChannel) {
      let diControl = this.selectedDiChannel.manualControl;
      if (diControl) {
        let parsedDiSettings = JSON.parse(diControl.settings);
        let parsedDi = parsedDiSettings.DI;
        this.state = parsedDiSettings.DI.State;
      } else {
      }
    }
  }

  public createDoControl(): void {
    this.setDoManualControl();
  }

  public turnDoControlOff(): void {
    let doControl = {
      active: false,
      state: true

    } as SetDoControl;
    if (this.selectedDiChannel) {
      this.dataEndChannelService.setDiManualControl(Number(this.selectedDiChannel.id), doControl).subscribe(resp => {
        this.alertService.alert('DI Control wurde ausgeschaltet', AlertTypes.success);

      });
    } else {
      this.alertService.alert('Fehler beim setzen', AlertTypes.error);
    }
  }

  onStateChanged(): void {
    this.stateChanged = true;
  }

  public setDoManualControl(): void {
    let doControl = {
      active: true,
      state: this.state
    } as SetDoControl;

    if (this.selectedDiChannel) {
      this.dataEndChannelService.setDiManualControl(Number(this.selectedDiChannel.id), doControl).subscribe(resp => {

        this.alertService.alert('DI Control wurde erstellt', AlertTypes.success);
      });
    } else {
      this.alertService.alert('Fehler beim setzen', AlertTypes.error);
    }
  }
}